const sh = require('shelljs')
const { begin } = require('../common.js')
const { name } = require('../../package.json')

module.exports = yargs => {
    begin('update')    
    sh.exec(`npm install -g ${name}@latest`)
}


// WEBPACK FOOTER //
// ./src/commands/update.js